import React from "react";
import ForRentWigsDetails from "./for-rent-wigs-details/for-rent-wigs-details";

const ForRentWigsDetailsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForRentWigsDetails/>
            </div>
        </>
    )
};

export default ForRentWigsDetailsContainer;